import React, { useState } from "react";
import { Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import "./Flexiaccessincomeillustrationmodal.scss";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import Buttons from "../../atoms/Buttons";
import { addCommas, calculateDuration } from "../../helpers/helpers";
import { Link } from "react-router-dom";
import NotFound from "../../atoms/NotFound";

const FlexiAccessIncomeIllustrationModal = (props) => {
  const [agreeChanges, setAgreeChanges] = useState(false);

  const agreeChangesHandle = () => {
    setAgreeChanges(!agreeChanges);
  };

  const selfManagedTooltip = (
    <Popover id="dd-pop-id" className="dd-popover-inner">
      <Popover.Body className="dd-popover-body">
        <div className="pop-text">
          This drawdown option enables you to choose your investments and income
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <div className="faii-parent">
      <div className="faii-cross text-end">
        <Link to="">
          <Icons
            iconname="close-large"
            variant="icon-sixteen-px"
            clickHandler={props.handleCloseButton}
          />
        </Link>
      </div>
      <Row className="faii-title mb-3">
        <Col>
          <div>{props.modalTitle}</div>
        </Col>
      </Row>
      <Row className="faii-sub-title">
        <Col>
          <div className="mb-3">
            Below is an estimated forecast of your flexi-access drawdown income.
            You have invested{" "}
            <b>
              £
              {props.directFromManage
                ? addCommas(Math.trunc(props.updatedFlexiObject.currentValue))
                : addCommas(
                    Math.trunc(props.updatedFlexiObject.newCurrentValue),
                  )}
              .
              <span className="eac-pot-value-small-digit">
                {(props.updatedFlexiObject.currentValue % 1)
                  .toFixed(2)
                  .substring(2)}
              </span>{" "}
            </b>{" "}
            and would like to receive{" "}
            <b>
              £{addCommas(Math.trunc(props.flexiAcessCurrentIncome))}.
              <span className="eac-pot-value-small-digit">
                {(props.flexiAcessCurrentIncome % 1).toFixed(2).substring(2)}
              </span>{" "}
              every{" "}
              {props.flexiAccessDuration === "Annually"
                ? "year"
                : props.flexiAccessDuration === "Half yearly"
                  ? "half-year"
                  : props.flexiAccessDuration === "Quarterly"
                    ? "quarter"
                    : "month"}
              .
            </b>
          </div>
        </Col>
      </Row>
      {parseFloat(props.flexiAcessCurrentIncome) > 0 ? (
        <Row className="faii-sub-title mb-5">
          <Col>
            <div>
              Therefore, you may run out of money in{" "}
              <b>
                {
                  calculateDuration(
                    props.directFromManage
                      ? props.updatedFlexiObject.currentValue
                      : props.updatedFlexiObject.newCurrentValue,
                    props.flexiAcessCurrentIncome,
                    props.flexiAccessDuration === "Annually"
                      ? 12
                      : props.flexiAccessDuration === "Half yearly"
                        ? 6
                        : props.flexiAccessDuration === "Quarterly"
                          ? 3
                          : 1,
                  )?.years
                }
              </b>{" "}
              years and{" "}
              <b>
                {
                  calculateDuration(
                    props.directFromManage
                      ? props.updatedFlexiObject.currentValue
                      : props.updatedFlexiObject.newCurrentValue,
                    props.flexiAcessCurrentIncome,
                    props.flexiAccessDuration === "Annually"
                      ? 12
                      : props.flexiAccessDuration === "Half yearly"
                        ? 6
                        : props.flexiAccessDuration === "Quarterly"
                          ? 3
                          : 1,
                  )?.months
                }
              </b>{" "}
              months.
            </div>
          </Col>
        </Row>
      ) : (
        ""
      )}
      <Row className="faii-summary-of-change mb-5 d-none d-xl-block d-lg-block d-md-block">
        <Col>
          <table>
            <thead>
              <tr>
                <th className="ps-4">
                  Self managed{" "}
                  <OverlayTrigger
                    placement="right"
                    overlay={selfManagedTooltip}
                    flip={true}
                  >
                    <span className="fa-tooltip">
                      <Icons
                        iconname="tool-tip-white"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  </OverlayTrigger>
                </th>
                <th className="col-pad-allocation">Allocation</th>
                <th className="col-pad-total-value">Estimated value</th>
                <th className="col-pad-total-value">Your drawdown income</th>
              </tr>
            </thead>
            <tbody>
              <tr className="mt-3">
                <td className="ps-4">
                  <span>Flexi-access</span>
                </td>
                <td className="col-pad-allocation">
                  {props.initialFlexiObject.strategyPercentage}%{" "}
                  <Icons
                    iconname="arrow-right-fuchsia"
                    variant="icon-sixteen-px"
                  />{" "}
                  <b>{props.updatedFlexiObject.strategyPercentage}%</b>
                </td>
                <td className="col-pad-total-value">
                  £
                  {addCommas(
                    Math.trunc(props.updatedFlexiObject.newCurrentValue),
                  )}
                  .
                  <span className="eac-pot-value-small-digit">
                    {(props.updatedFlexiObject.currentValue % 1)
                      .toFixed(2)
                      .substring(2)}
                  </span>{" "}
                </td>
                <td>
                  £
                  {addCommas(
                    Math.trunc(props.initialFlexiObject.currentIncome),
                  )}
                  .
                  <span className="eac-pot-value-small-digit">
                    {(props.initialFlexiObject.currentIncome % 1)
                      .toFixed(2)
                      .substring(2)}
                  </span>{" "}
                  <Icons
                    iconname="arrow-right-fuchsia"
                    variant="icon-sixteen-px"
                  />{" "}
                  <b>
                    £{addCommas(Math.trunc(props.flexiAcessCurrentIncome))}.
                    <span className="eac-pot-value-small-digit">
                      {(props.flexiAcessCurrentIncome % 1)
                        .toFixed(2)
                        .substring(2)}{" "}
                      {props.flexiAccessDuration?.toLowerCase() ===
                      "Monthly".toLowerCase()
                        ? "p/m"
                        : props.flexiAccessDuration?.toLowerCase() ===
                            "Quarterly".toLowerCase()
                          ? "p/q"
                          : props.flexiAccessDuration?.toLowerCase() ===
                              "Half yearly".toLowerCase()
                            ? "p/6m"
                            : props.flexiAccessDuration?.toLowerCase() ===
                                "Annually".toLowerCase()
                              ? "p/y"
                              : ""}
                    </span>
                  </b>
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
      <Row>
        <Col className="check-text mb-5">
          <CustomCheckbox
            name="agreeChange"
            type="checkbox"
            variantName="declare-check-box"
            checked={agreeChanges}
            onChange={agreeChangesHandle}
            label="I understand and agree to the above changes"
          />
        </Col>
      </Row>
      {props.flexiAccessError && props.errorShown === true ? (
        <div className="mt-3 mb-3">
          <NotFound err={props.flexiAccessError} />
        </div>
      ) : (
        ""
      )}
      <Row>
        <Col>
          <div className="faii-summary-footer-button">
            <div className="faii-modal-button">
              <Buttons
                name="Proceed"
                className="primary"
                variantname="icon-sixteen-px"
                disabled={agreeChanges ? false : true}
                handleClick={props.handleIllustrationContinue}
                flexiAccessFetching={props.flexiAccessFetching}
              ></Buttons>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FlexiAccessIncomeIllustrationModal;
